import { number, object } from 'yup';

export const durationSchema = object({
  value: number().nullable(),
  factor: number().nullable(),
}).nullable();
